<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button *ngIf="toShowEmployees" (click)="hideEmployee()">
      <mat-icon>close</mat-icon>
    </button>
    <button mat-icon-button mat-dialog-close *ngIf="!toShowEmployees">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content *ngIf="!toShowEmployees">
    <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Name</mat-label>
        <input [(ngModel)]="newbookingData.customerName" matInput [matAutocomplete]="auto"/>
        
      </mat-form-field>

    <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let item of filteredList" [value]="item" (click)="onClickName(item)">
            {{item.name}}
        </mat-option>
    </mat-autocomplete>
    </div>
    <!-- <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Phone</mat-label>
        <input [(ngModel)]="newbookingData.customerPh" matInput  type="tel" smNumericOnly
        maxlength="10"/>
        
      </mat-form-field>
    </div> -->

  
    <div class="row g-2  justify-content-between phone-field">
      <mat-form-field appearance="outline" class="country-code col-3">
        <mat-label>Country Code</mat-label>
        <mat-select
        [(ngModel)]="selectedCountryCode"
        required
        (selectionChange)="onCountrySelected($event)"
      >
        <mat-select-trigger>
          {{ selectedCountryCode.flag }} {{ selectedCountryCode.name }}
              {{ "(" + selectedCountryCode.dial_code + ")" }}
        </mat-select-trigger>
        
        <mat-option>
          <ngx-mat-select-search
            noEntriesFoundLabel="no results found"
            name="countrysearch"
            placeholderLabel="Enter country name"
            [formControl]="searchString"
            (keyup)="onKey()"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let country of countryList" [value]="country">
          {{ country.flag }} {{ country.name }}
          {{ "(" + country.dial_code + ")" }}
        </mat-option>
      </mat-select>
      </mat-form-field>
      <mat-form-field class="mobile_form col-9" appearance="outline" >
        <mat-label>Phone</mat-label>
        <input [(ngModel)]="newbookingData.customerPh" matInput  type="tel" smNumericOnly
        minLength="3"
                  maxlength="17">
        <mat-hint style="color: red;
    font-size: 13px;" align="end" *ngIf="newbookingData.customerPh && newbookingData.customerPh != '' &&  newbookingData.customerPh.length < 3 ">Enter a valid phone number.</mat-hint>
      </mat-form-field>
    </div>

    <h3 class="servicet_heading">Service/subscription period</h3>
    <div class="chip_cont" style=" margin-top: 15px;display: flex; margin-bottom: 20px;">
    <mat-chip-listbox aria-label="Fish selection" class="mb-3">
      <mat-chip style="margin-right: 12px;"
        [ngClass]="{ selectedPurple: selectedFromDate }"
        (click)="onSelectDate(1)"
        >{{ selectedFromDate ? (selectedFromDate | date : "longDate") : "From Date" }}
      </mat-chip>
    </mat-chip-listbox>
    <mat-chip-listbox aria-label="Fish selection" class="mb-3" style="display: flex;justify-content: center;font-size: 16px; align-items: center;">
      <span style="display: block; padding-right: 8px; padding-left: 5px;">to</span>
    </mat-chip-listbox>
    <mat-chip-listbox aria-label="Fish selection" class="mb-3">
      <mat-chip  
        [ngClass]="{ selectedPurple: selectedToDate }"
        (click)="onSelectDate(2)"
        >{{ selectedToDate ? (selectedToDate | date : "longDate") : "To Date" }}
      </mat-chip>
    </mat-chip-listbox>
  </div>

  <!-- <h3 class="servicet_heading">Service type</h3>
  <div class="form-group service-button" style="margin-top: 16px;border-bottom: 1px solid lightgray;padding-bottom: 16px;">
    <mat-chip-listbox class="example-chip">
        <mat-chip *ngIf="shop_status != 2" [ngClass]="{ 'selected': selectedServiceType == '1' }" (click)="changeServiceType('1')">{{isEntityIndividual == '0' ?  'Shop service' : 'In-premise service'}}</mat-chip>
        <mat-chip *ngIf="home_status != 2" [ngClass]="{ 'selected': selectedServiceType == '0' }" (click)="changeServiceType('0')">Home service</mat-chip>
        <mat-chip *ngIf="virtual_status != 2" [ngClass]="{ 'selected': selectedServiceType == '2' }" (click)="changeServiceType('2')">Virtual service</mat-chip>
    </mat-chip-listbox>
</div> -->

<h3 class="servicet_heading" *ngIf="isEntityIndividual == '0'">  {{ this.selectedServiceType == "1" ? "Shop services" : (this.selectedServiceType == '0' ? 'Home services' : "Virtual services") }}</h3>
<h3 class="servicet_heading" *ngIf="isEntityIndividual == '1'">  {{ this.selectedServiceType == "1" ? "In-premise services" : (this.selectedServiceType == '0' ? 'Home services' : "Virtual services") }}</h3>
    <!-- <p style="margin: 20px 0 0px">
      
      </p> -->
    <div class="chip_cont" style="padding: 20px 0px;">
      <mat-chip-listbox class="example-chip" *ngIf="serviceList.length > 0">
        <div *ngFor="let item of serviceList">
          <mat-chip
            *ngIf="item.toShow"
            
            (click)="selectServices(item)"
            >{{ item.serviceName }}
          </mat-chip>
        </div>
     

      </mat-chip-listbox>
      <p *ngIf="serviceList.length == 0" style="color: #a6a6a6;">No service added</p>
      </div>

      <h3 class="servicet_heading" *ngIf="productsList.length > 0"> Sellable products</h3>
      <div class="chip_cont" style="padding: 20px 0px;" *ngIf="productsList.length > 0">
        <mat-chip-listbox class="example-chip" *ngIf="productsList.length > 0">
          <div *ngFor="let item of productsList">
            <mat-chip
              *ngIf="item.toShow"
              
              (click)="selectProducts(item)"
              >{{ item.product_name }}
            </mat-chip>
          </div>
       
        </mat-chip-listbox>
        <p *ngIf="productsList.length == 0" style="color: #a6a6a6;">No product added</p>
      </div>

  <h3 style="color: #222; font-weight: bold;" *ngIf="completedJobs.length > 0">Job completed</h3>
    <div class="chip_cont">
      <div class="" *ngIf="completedJobs.length > 0">
        <div class="job_complete_section" *ngFor="let item of completedJobs; let i = index;">
          <div class="first_div">
            <div
              style="
                display: inline-block;
                width: fit-content;
                background: #ffc107;
                padding: 8px 20px;
                border-radius: 34px;
                margin-bottom: 20px;">
              <p style="margin: 0px; font-weight: 500; font-size: 16px">
                {{ item.service_name }}
              </p>
            </div>
            <div class="produce_bill_sec">
              <div style="display: inline-block;">
                 <span style="margin-left: 10px;border: 1px solid #a2a2a2;padding: 10px;border-radius: 10px;">
                <button
                (click)="decreaseServiceCount(item,i)"
                style="background: none;
                border: 1px solid #a2a2a2;
                border-radius: 25px;
                width: 25px;
                height: 25px;">
                <mat-icon class="material-icons-outlined" style="    font-size: 16px;
                position: relative;
                top: 2px;
                left: -3px;
                color: #666666;
                height: auto;
                width: auto;">remove</mat-icon>
                </button>
                <span style="margin: 0 15px;"> {{item.total_completed_services_qty}} </span>
                <button 
                (click)="increaseServiceCount(item,i)"
                style="background: none;
                border: 1px solid #a2a2a2;
                border-radius: 25px;
                width: 25px;
                height: 25px;">
                <mat-icon style="    font-size: 16px;
                position: relative;
                top: 2px;
                left: -3px;
                color: #666666;
                height: auto;
                width: auto;" class="material-icons-outlined">add</mat-icon>
                </button>
              </span>
            </div>
            <div class="second-div" style="padding: 0;">
              <div class="th_heading">
                  <input [(ngModel)]="item.price" matInput  smDecimalOnly  type="number"  (ngModelChange)="changeServicePrice(item)"/>
              </div>
          </div>
        </div>
          <div class="bill_down_flex">
              <span (click)="removeCompletedJobs(item)" style="margin-left: 20px; display: inline-block; cursor: pointer;">
                Remove
              </span>
          </div>
        </div>
        </div>
      </div>
      </div>


  <!-- COMPLETED PRODUCTS -->
    <h3 style="color: #222; font-weight: bold;" *ngIf="completedProducts.length > 0">Products selected</h3>
     <div class="chip_cont">
        <div class="" *ngIf="completedProducts.length > 0">
          <div class="job_complete_section" *ngFor="let item of completedProducts; let i = index;">
            <div class="first_div">
              <div
                style="
                display: inline-block;
                width: fit-content;
                background: #ffc107;
                padding: 8px 20px;
                border-radius: 34px;
                margin-bottom: 20px;">
              <p style="margin: 0px; font-weight: 500; font-size: 16px">
                {{ item.product_name }}
              </p>
            </div>
            <!-- <mat-icon style="font-size: 20px;font-weight: 900;color: #000; position: relative; top: 4px; margin-left: 10px;">close</mat-icon> -->
            <div class="produce_bill_sec">
            <div style="display: inline-block;">
              <span style="margin-left: 10px;border: 1px solid #a2a2a2;padding: 10px; border-radius: 10px;">
                <button
                (click)="decreaseProductCount(item,i)"
                style="background: none;
                border: 1px solid #a2a2a2;
                border-radius: 25px;
                width: 25px;
                height: 25px;">
                <mat-icon class="material-icons-outlined" style="    font-size: 16px;
                position: relative;
                top: 2px;
                left: -3px;
                color: #666666;
                height: auto;
                width: auto;">remove</mat-icon>
                </button>
                <span style="    margin: 0 15px;"> {{item.total_completed_services_qty}} </span>
                <button 
                (click)="increaseProductCount(item,i)"
                style="background: none;
                border: 1px solid #a2a2a2;
                border-radius: 25px;
                width: 25px;
                height: 25px;">
                <mat-icon style="    font-size: 16px;
                position: relative;
                top: 2px;
                left: -3px;
                color: #666666;
                height: auto;
                width: auto;" class="material-icons-outlined">add</mat-icon>
                </button>
              </span>
              
              
            </div>
            <div class="second-div" style="padding: 0;">
              <div class="th_heading">
              <input [(ngModel)]="item.price" matInput  smDecimalOnly  type="number"  (ngModelChange)="changeProductPrice(item)"/>
              </div>
            </div>
            </div>
            <div class="bill_down_flex">
              <span (click)="removeCompletedProducts(item)"
              style="margin-left: 20px; display: inline-block; cursor: pointer;">
                Remove
              </span>
              </div>
          </div>
        </div>
      </div>
      </div>

   <!-- create invice new design added -->
   <div class="other_itemi_secty">
    <div class="oth_headingrt">
      <h3>Other items</h3>
    </div>
    <form [formGroup]="form">
      <div formArrayName="items">
        <div *ngFor="let item of items.controls; let i = index" [formGroupName]="i" class="repect_under">
          <div class="row">
            <div class="col-sm-3">
              <div class="item_name_tht">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Item name</mat-label>
                  <input matInput formControlName="name" [matAutocomplete]="auto" type="text" placeholder="Enter item name">
                  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayItemName">
                    <mat-option *ngFor="let option of filteredOptions[i] | async" [value]="option">
                      {{ option.item_name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-3">
              <mat-form-field appearance="outline" >
                <mat-select class="w-100" formControlName="tax_slab">
                  <mat-option value="default" >
                    Select a tax
                  </mat-option>
                  <mat-option [value]="item.hash_id" *ngFor="let item of taxSlabData">
                    {{isEntityForeign == '0' ? item.tax_name : item.slab_name}}
                  </mat-option>
                  
                </mat-select>
              </mat-form-field>
            </div>

            <div class="adsfer">
              <div class="plus_tht newclassw">
                     <div class="flexsc">
                <div class="inc_dec_cont newinc">
                  <span class="cont_span" style="top: 2px;border: 1px solid #a2a2a2;padding: 13px !important;border-radius: 10px; position: relative; bottom: 0px;  width: 125px; display: block;  margin-right: 10px;">
                    <button type="button" class="inc_dec_btn"  (click)="decreaseCount(i)">
                      <mat-icon>remove</mat-icon>
                    </button>
                    <span style="margin: 0 15px;">{{ item.get('count')!.value }}</span>
                    <button type="button" class="inc_dec_btn"  (click)="increaseCount(i)">
                      <mat-icon>add</mat-icon>
                    </button>
                  </span>
                </div>
                </div>
                <div class="item_name_tht itempricex">
                  <mat-form-field appearance="outline" class="full-width" style="width: 97%;">
                    <mat-label>Item price</mat-label>
                    <input matInput formControlName="price" placeholder="Enter item price" smDecimalOnly  type="number" >
                  </mat-form-field>
                </div>
              </div>
           
            <span class="remove_btn" (click)="removeFormField(i)">
              Remove
            </span>
          </div>
        </div>
        </div>
      </div>
    
      <div class="add_item_btbh">
        <button type="button" mat-flat-button color="accent" (click)="addFormField()">
          <mat-icon>add</mat-icon>
          Add item
        </button>
      </div>
    </form>
    

  </div>


  <!-- create invice new design end -->



   
    <div style="border-bottom: 1px solid lightgray;">
        <div class="open_table" style="margin-bottom: 20px; padding: 0 18px 0 0">
            <div class="discount_list" style="font-size: 16px;">Total</div>
            <div class="discount_list" style="text-align: right; font-size: 16px;">
                  {{newbookingData.price.toFixed(2)}}
                </div>
         
        </div>
        <div class="open_table" style="margin-bottom: 20px; padding: 0 18px 0 0" *ngIf="selectedMember.coupon_code">
            <div class="discount_list" style="font-size: 16px;">Coupon discount <span style="margin-left: 5px;" *ngIf="this.selectedMember?.coupon_use_limit != 0 && (this.selectedMember?.coupon_use_limit == this.selectedMember?.coupon_use_counter)">(Expired)</span></div>
            <div class="discount_list" style="text-align: right; font-size: 16px;">
                  {{newbookingData.coupon_discount.toFixed(2)}}
                </div>
         
        </div>
        <div class="open_table" style="padding: 0 18px 0 0;margin-bottom: 40px; ">
            <div class="discount_list" style="font-size: 16px;color:#000">Discount</div>
            <div class="discount_list" style="text-align: right;">
               <div class="small-height-input">
                    <input [(ngModel)]="newbookingData.discount" matInput  smDecimalOnly  type="number" (ngModelChange)="changedDiscountByBusiness($event)" />
               </div>
                </div>
         
        </div>
       
    </div>

    <div>
        <div class="open_table" style="margin-top: 20px; margin-bottom: 40px; padding: 0 18px 0 0">
            <div class="discount_list" style="font-size: 16px; font-weight: bold;">Net payable</div>
            <div class="discount_list" style="text-align: right; font-size: 16px;font-weight: bold;">
                  {{(newbookingData.price - newbookingData.discount - newbookingData.coupon_discount).toFixed(2)}}
                </div>
         
        </div>
    </div>
   
  </mat-dialog-content>
  
  <mat-dialog-actions align="end" *ngIf="!toShowEmployees">
<!-- 
    <button
    
    mat-button
    style="border: 1px solid #b48700;"
    [disabled]="
    !newbookingData.customerName || 
    !newbookingData.price ||
    completedJobs.length == 0
    "
    [disabled]="emptyCheck ||
      formChecker()"
    (click)="allDoneAndRelease()"
  >
    All done and release
  </button> -->
    <!-- <button mat-button   style="border: 1px solid #b48700;" [disabled]="
    !newbookingData.price ||
    completedJobs.length == 0
    "
    [disabled]="emptyCheck ||
      formChecker()"
    (click)="partiallyDone()"
    >Save as under process</button> -->
    <button mat-button mat-dialog-close>Cancel</button>
    <button
    
      mat-flat-button
      color="accent"
      (click)="onPost()"
      [disabled]="isSubmitDisabled"
    >
      Save
    </button>
  </mat-dialog-actions>
  
